import React from "react";

import { NotificationsTypes } from "../../../util/enums";
import StyledBadge from "../StyledBadge";

type Props = {
  value?: string;
  backgroundColor?: string;
  dataCy?: string;
  textColor?: string;
  className?: string;
};

const BadgeNotificationType = (props: Props) => {
  const { value, className, dataCy } = props;

  const renderBadge = (backgroundColor: string, textColor: string, value?: string) => {
    if (value)
      return (
        <StyledBadge
          dataCy={dataCy}
          backgroundColor={backgroundColor}
          textColor={textColor}
          value={value}
          className={className}
        />
      );

    return <> </>;
  };

  switch (value?.toLowerCase()) {
    case NotificationsTypes.WEB:
      return renderBadge("#E0F2FE", "#0086C9", value);
    case NotificationsTypes.SMS:
      return renderBadge("#E0EAFF", "#444CE7", value);
    case NotificationsTypes.MOBILE:
      return renderBadge("#FCE7F6", "#DD2590", value);
    default:
      return renderBadge("#e6fffd", "#00D0BD", value);
  }
};

export default BadgeNotificationType;
